import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useMedia from "use-media";
import { Label } from '../../atoms/label';
import { styles } from "./checkListPopupContainer";
import { ModalCheckboxList } from '../../molecules/modalCheckboxList';
// 複数選択ポップアップ
const MultiSelectPopup = (props) => {
    const { initialData,
        onDecice, // 決定処理
        onClose, // 閉じる処理
        show, // ダイアログ表示状態
        popupTitle,
        title,
        afterLabel,
        // ModalCheckboxListがinputのid指定してるから画面内で重複するとうまく動かないので区別するためのプレフィックス
        idPrefix, 
    } = props;


    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    // 入力中データ
    const [data, setData] = useState([]);


    // const popupRef = useRef(null);
    // useLayoutEffect(() => {
    //     console.log("★popupRef", popupRef);
    //     popupRef.current.scrollTop = 0;
    // }, [show]);

    const copy = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    }

    // ちらつき防止のためuseEffectでなくuseLayoutEffect
    useLayoutEffect(() => {
        if (show) {
            // ポップアップ用にコピー
            setData(initialData ? copy(initialData) : null)
        }
    }, [show]);// 初期表示後の初期化はしたくないからinitialDataに依存しない


    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);



    // 変更ハンドラ
    const handleChange = (name, groupIndex, index) => {
        const newData = [...data];
        newData[index].checked = !newData[index].checked;
        setData(newData);
    }

    return (
        <div  className={show ? "popupIsShow" : "popup"} id="js-popup">
            <div className="popupInner">
                <div className="popupHeader">
                    <div className="closeBtn" id="js-close-btn" onClick={onClose}>
                    </div>
                    <h4 className="popupInnerText" >{popupTitle}</h4>
                </div>
                <div >
                <div >
                    <Label className="popupTitle" label={title} />
                    <ModalCheckboxList
                        divStyle={isMobilePhone ? styles.divStyleSp : styles.divStyle}
                        checkAreaStyle={isMobilePhone ? styles.divItemStyleSp : styles.divItemStyle}
                        data={data.map(item=>({...item, id:`${idPrefix}_${item.id}`}))}
                        title={title}
                        name="grade"
                        groupIndex={0}
                        onChange={handleChange}
                        labelClassName={"shortening"}
                        afterLabel={afterLabel}
                        afterLabelClassName="membership_disabledLabel"
                    />
                </div>
                </div>

                <div className="buttonArea" >
                    <button id="checkListDecision" className="button" onClick={() => onDecice(data)}>決 定</button>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


export default MultiSelectPopup;